module.exports = __webpack_public_path__ + "public/img/promo-4.3f66758d.jpg";